import { useCallback, useEffect } from 'react';

import webSocketManager from '../../service/WebSocketManager';

/**
 * useCardGenerationSocketStats
 * @param {string} projectId
 * @param {object} actions - { onCreated, onGeneratingStart, onGeneratingFinish, onImageGenerated }
 */
function useCardGenerationSocketStats(projectId, promptType, actions) {
  const handleCreated = useCallback(
    (message) => {
      const frameId = message.body;
      actions.onCreated(frameId);
    },
    [actions],
  );

  const handleGeneratingStart = useCallback(
    (message) => {
      const frameId = message.body;
      actions.onGeneratingStart(frameId);
    },
    [actions],
  );

  const handleGeneratingFinish = useCallback(
    (message) => {
      const frameId = message.body;
      actions.onGeneratingFinish(frameId);
    },
    [actions],
  );

  const handleImageGenerated = useCallback(
    (message) => {
      const { bucketId, imageId } = JSON.parse(message.body);
      actions.onImageGenerated({ bucketId, imageId });
    },
    [actions],
  );

  const handleAllImagesGenerated = useCallback(() => {
    actions.onAllImagesGenerated();
  }, [actions]);

  useEffect(() => {
    if (!projectId) return;

    const stompClient = webSocketManager.getProjectConnection(projectId);

    stompClient.onConnect = () => {
      stompClient.subscribe(`/id8/content/generating/bucket/start/${projectId}/${promptType}`, handleGeneratingStart);
      stompClient.subscribe(`/id8/content/generating/bucket/finish/${projectId}/${promptType}`, handleGeneratingFinish);
      stompClient.subscribe(`/id8/content/image/${projectId}/${promptType}`, handleImageGenerated);
      stompClient.subscribe(
        `/id8/content/global/generating/finish/${projectId}/${promptType}`,
        handleAllImagesGenerated,
      );
    };
  }, [
    projectId,
    promptType,
    handleCreated,
    handleGeneratingStart,
    handleGeneratingFinish,
    handleImageGenerated,
    handleAllImagesGenerated,
  ]);
}

export default useCardGenerationSocketStats;
